import { styled, TextField } from '@mui/material';
import React from 'react';

const TimeTextField = styled(TextField)({
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: '#134C03'
        },
        '&:hover fieldset': {
            borderColor: '#134C03'
        },
        '&.Mui-focused fieldset': {
            borderColor: '#134C03'
        }
    }
});

interface TimeTextComponentProps {
    type: string;
    name: string;
    width: string;
    value: string | number | null | undefined;
}

export function TimeTextComponent({
    type,
    name,
    width,
    value
}: TimeTextComponentProps): JSX.Element {
    return (
        <TimeTextField
            required
            margin="dense"
            id={name}
            type={type}
            name={name}
            value={value}
            sx={{
                width: 127,
                marginBottom: '15px',
                font: 'normal normal medium 24px Roboto'
            }}
        />
    );
}
